import { render, staticRenderFns } from "./McPieChart.vue?vue&type=template&id=a59e871a&"
import script from "./McPieChart.vue?vue&type=script&lang=js&"
export * from "./McPieChart.vue?vue&type=script&lang=js&"
import style0 from "./McPieChart.vue?vue&type=style&index=0&id=a59e871a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports